export default __webpack_public_path__ + "static/media/higher_primary_logo_tagline_url.74946202.svg";